import { useLang } from "@/context/LangContext";
import { Languages } from "lucide-react";

const ORDER = ["en", "hi"];
const LABEL = { en: "EN", hi: "हिं" };

export const LangToggle = ({ variant = "default" }) => {
  const { lang, setLang } = useLang();
  const isDark = variant === "dark";
  const cycle = () => {
    const i = ORDER.indexOf(lang);
    setLang(ORDER[(i + 1) % ORDER.length]);
  };
  return (
    <button
      data-testid="lang-toggle"
      onClick={cycle}
      title={`Language: ${LABEL[lang]}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-md transition-colors border ${
        isDark
          ? "border-white/20 text-white/90 hover:bg-white/10"
          : "border-slate-200 text-slate-700 hover:bg-slate-100 bg-white"
      }`}
    >
      <Languages className="w-3.5 h-3.5" />
      {ORDER.map((l, i) => (
        <span key={l} className={lang === l ? "font-bold text-[#0A3161]" : "opacity-40"}>
          {LABEL[l]}{i < ORDER.length - 1 && <span className="ml-1 opacity-40">/</span>}
        </span>
      ))}
    </button>
  );
};
